module.exports = __webpack_public_path__ + "assets/Overbite.597ee5a5e7069ff86a47af16e8385e7a.png";